import { render } from "./CommandesClientView.vue?vue&type=template&id=0c5daa5a&scoped=true"
import script from "./CommandesClientView.vue?vue&type=script&lang=js"
export * from "./CommandesClientView.vue?vue&type=script&lang=js"

import "./CommandesClientView.vue?vue&type=style&index=0&id=0c5daa5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c5daa5a"]])

export default __exports__